<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link"
                        class="list-view-icon-btn"
                        :class="{ 'list-view-icon-btn--active': filtersOpen }"
                        v-b-tooltip.hover.bottom
                        :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        @click="filtersOpen = !filtersOpen">
                <AppIcon name="filter" :fill="filtersOpen" />
              </b-button>
              <b-dropdown v-if="configSubView.elements.mobile_order_create"
                          right
                          no-caret
                          variant="link"
                          boundary="window"
                          toggle-class="list-view-icon-btn list-view-icon-btn--primary"
                          v-b-tooltip.hover.bottom
                          title="Agregar Pedido">
                <template #button-content>
                  <AppIcon name="add" label="Agregar Pedido" />
                </template>
                <b-dropdown-item @click="add()"><AppIcon name="add" /> Pedido Original</b-dropdown-item>
                <b-dropdown-item @click="openMobileOrderCreate()"><AppIcon name="phone" /> Nuevo Pedido (Mobile)</b-dropdown-item>
              </b-dropdown>
              <b-button v-else
                        variant="link"
                        class="list-view-icon-btn list-view-icon-btn--primary"
                        v-b-tooltip.hover.bottom
                        title="Agregar Pedido"
                        @click="add()">
                <AppIcon name="add" label="Agregar Pedido" />
              </b-button>
            </div>
          </div>
        </section>

        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="width: 150px;">
              <label class="filter-label">Nº Pedido</label>
              <b-form-input type="number" size="sm" placeholder="Buscar por Nº" v-model="filters.number" v-on:keyup.enter.native="filterOrders()"></b-form-input>
            </div>
            <div class="list-view-filter" style="width: 150px;">
              <label class="filter-label">Desde</label>
              <b-form-input type="date" size="sm" v-model="filters.date_start"></b-form-input>
            </div>
            <div class="list-view-filter" style="width: 150px;">
              <label class="filter-label">Hasta</label>
              <b-form-input type="date" size="sm" v-model="filters.date_end"></b-form-input>
            </div>
            <div class="list-view-filter" style="flex: 1 1 230px; max-width: 340px;">
              <label class="filter-label">Clientes</label>
              <v-select :options="arr.filters.customers" v-model="filters.customers" placeholder="Todos" :multiple="true" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 190px; max-width: 260px;">
              <label class="filter-label">Estado</label>
              <v-select :options="arr.filters.status" v-model="filters.status" placeholder="Todos" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 190px; max-width: 260px;">
              <label class="filter-label">Punto de Venta</label>
              <v-select :options="arr.filters.points_sales" v-model="filters.points_sales" placeholder="Todos" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 190px; max-width: 260px;" v-if="parameters.haveReason">
              <label class="filter-label">Motivos</label>
              <v-select :options="arr.filters.reasons" v-model="filters.reason" placeholder="Todos" :multiple="true" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 190px; max-width: 260px;" v-if="moduleSalesActive">
              <label class="filter-label">Facturación</label>
              <v-select :options="arr.filters.invoiced" v-model="filters.invoiced" placeholder="Todos" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <b-button variant="outline-dark" size="sm" @click="filterOrders()" v-b-tooltip.hover title="Aplicar filtros" style="height: 31px; width: 31px; padding: 0; flex-shrink: 0;">
              <AppIcon name="filter" />
            </b-button>
          </div>
        </b-collapse>
      </b-card>

      <b-row>
        <b-col lg="12">
          <b-card no-body>
            <b-tabs pills card :vertical="!isMobileViewport" class="crud-orders-view-tabs">
              <b-tab>
                <template #title>
                  <AppIcon name="cart" label="Pedidos" font-scale="1.5" />
                </template>
                <b-card-text>
                  <b-card>
                    <b-row>
                      <b-col sm="12">
                        <b-form-checkbox v-model="filters.show_total_iva"
                                          switch
                                          size="sm"
                                          class="pull-left mb-2"
                                          @input="filterOrders()">
                          Mostrar totales con IVA incluido
                        </b-form-checkbox>
                      </b-col>
                      <b-col sm="12">
                        <b-table class="app-table"
                                ref="table"
                                responsive
                                :stacked="isMobileViewport ? 'md' : false"
                                sticky-header="60vh"
                                :hover="true"
                                :small="true"
                                :fixed="true"
                                :items="table.items"
                                :fields="table.fields"
                                :filter="table.filter"
                                :current-page="table.currentPage"
                                :per-page="table.perPage"
                                @row-clicked="onRowClicked"
                                :tbody-tr-class="rowClass"
                                :busy="table.isBusy"
                                v-if="table.items.length || table.isBusy">

                            <template v-slot:table-colgroup="scope">
                              <col
                                v-for="field in scope.fields"
                                :key="field.key"
                                :style="{ width: field.width }"
                              >
                            </template>

                            <template v-slot:table-busy>
                              <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Cargando...</strong>
                              </div>
                            </template>

                            <template v-slot:cell(business)="data">
                              <div v-if="data.item.points_sales && data.item.points_sales.business">
                                {{data.item.points_sales.business.reference}}
                              </div>
                            </template>

                            <template v-slot:cell(id)="data">
                              <div title="Numeración del sistema" class="text-nowrap" v-if="data.item.points_sales">
                                PEDIDO {{data.item.points_sales.point_sale.toString().padStart(4,'0') + '-' + data.item.id.toString().padStart(8,'0')}}
                              </div>
                              <div v-if="data.item.nro_order_internal"
                                  title="Numeración de un sistema externo"
                                  class="crud-orders-nro-internal">
                                <AppIcon name="link-45deg" />
                                <b>{{data.item.nro_order_internal}}</b>
                              </div>
                            </template>

                            <template v-slot:cell(date)="data">
                              {{moment(data.item.date).format('DD/MM/YYYY')}}
                            </template>

                            <template v-slot:cell(customers_id)="data">
                              <div v-if="data.item.customer">
                                <b-avatar :src="data.item.customer.image"
                                          v-if="data.item.customer.image">
                                </b-avatar>
                                <b-avatar v-else
                                          :text="avatarFromName(data.item.customer.name).text"
                                          :style="avatarFromName(data.item.customer.name).style">
                                </b-avatar>
                                &nbsp;<b>{{data.item.customer.name}}</b>

                                <span v-if="data.item.customer.bcra_status">
                                  <span v-if="data.item.customer.bcra_status.situacion > situationCreditMax">
                                    &nbsp;
                                    <b-badge variant="danger" :id="'popover-situation-' + data.item.id">
                                      Sit {{data.item.customer.bcra_status.situacion}}
                                    </b-badge>
                                    <b-popover :target="'popover-situation-' + data.item.id" variant="danger" triggers="hover">
                                      <template #title>Riesgo Creditício</template>
                                      <div v-html="situationCreditMessage(data.item)"></div>
                                    </b-popover>
                                  </span>
                                </span>

                                <AppIcon name="circle-fill" v-if="!data.item.customer.active" class="ml-2 text-danger" v-b-tooltip.hover title="Cliente INACTIVO" />
                              </div>
                            </template>

                            <template v-slot:cell(total)="data">
                              <div v-if="data.item.status!='in_process'">
                                <div v-if="data.item.paid" class="order-total-table-paid">
                                  <span v-if="filters.show_total_iva">
                                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.origin_currency_code}).format(data.item.totalIva)}}
                                  </span>
                                  <span v-else>
                                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.origin_currency_code}).format(data.item.total)}}
                                  </span>
                                </div>
                                <div v-else class="order-total-table-nopaid">
                                  <span v-if="filters.show_total_iva">
                                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.origin_currency_code}).format(data.item.totalIva)}}
                                  </span>
                                  <span v-else>
                                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.origin_currency_code}).format(data.item.total)}}
                                  </span>
                                </div>
                              </div>
                            </template>

                            <template v-slot:cell(status)="data">
                              <div v-html="getStatusName(data.item)"></div>
                            </template>

                            <template v-slot:cell(reason)="data">
                              <div v-if="data.item.reason">
                                <span v-if="data.item.reason.reference">
                                  {{data.item.reason.reference}}
                                </span>
                                <span v-else>
                                  {{data.item.reason.name}}
                                </span>
                              </div>
                            </template>

                            <template v-slot:cell(status_system_manufacture)="data">
                              <span v-if="data.item.status_system_manufacture">
                                <span v-if="JSON.parse(data.item.status_system_manufacture).status == 'error'" v-b-tooltip.hover :title="JSON.parse(data.item.status_system_manufacture).message">
                                  <AppIcon name="exclamation-triangle" class="text-danger" />
                                </span>
                              </span>
                            </template>

                            <template v-slot:cell(observations)="data">
                              <div v-if="data.item.observation">
                                <span v-if="isMobileViewport">{{data.item.observation}}</span>
                                <span v-else v-b-tooltip.hover :title="data.item.observation"><AppIcon name="chat-square-text" /></span>
                              </div>
                              <div v-if="data.item.observations_external">
                                <span v-if="isMobileViewport" v-html="data.item.observations_external" class="text-info"></span>
                                <span v-else :id="'popover-observations-external-' + data.index" class="text-info"><AppIcon name="chat-square-text" /></span>
                              </div>
                              <b-popover :target="'popover-observations-external-' + data.index"
                                        variant="danger"
                                        triggers="hover"
                                        v-if="data.item.observations_external && !isMobileViewport">
                                <template #title>Notas</template>
                                <div v-html="data.item.observations_external"></div>
                              </b-popover>
                            </template>

                            <template v-slot:cell(paid_info)="data">
                              <div v-if="data.item.paid_info" v-b-tooltip.hover :title="data.item.paid_info">
                                <AppIcon name="money" />
                              </div>
                            </template>

                            <template v-slot:cell(delivery_code_tracking)="data">
                              <div v-if="data.item.delivery_code_tracking" v-b-tooltip.hover :title="data.item.delivery_code_tracking">
                                <AppIcon name="truck" />
                              </div>
                            </template>

                            <template v-slot:cell(invoice)="data">
                              <div v-if="data.item.sale_id" v-b-tooltip.hover :title="getInvoiceTitle(data.item)">
                                <AppIcon name="receipt_long" />
                              </div>
                            </template>
                        </b-table>
                        <EmptyState v-else icon="cart" title="No se encontraron pedidos" description="Ajustá los filtros o el rango de fechas para ampliar la búsqueda, o generá un pedido nuevo con el botón Agregar." />

                        <div class="app-table-footer">
                          <span class="list-view-toolbar__count" v-if="table.tablePaginate">{{ table.tablePaginate.total }} registros</span>
                          <export-excel
                              class="list-view-link"
                              :data="arr.export"
                              worksheet="Listado de Pedidos"
                              name="list-orders.xls">
                              <AppIcon name="download" class="mr-1" /> Exportar
                          </export-excel>
                        </div>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-card-text>
              </b-tab>
              <b-tab @click="filterOrdersMetrics()">
                <template #title>
                  <AppIcon name="graph-up" label="Métricas" font-scale="1.5" />
                </template>
                <b-card-text>
                  <Metrics types="orders" :filters="filters" :key="itemFilterForceUpdate" v-if="itemFilterForceUpdate>0" @refresh="filterOrdersMetrics" />
                </b-card-text>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>

      <!-- DRAWER: detalle del pedido seleccionado -->
      <b-sidebar
          id="sidebar-order-seller-detail"
          v-model="detailDrawer"
          right
          shadow
          backdrop
          title="Detalle del Pedido"
          width="420px"
          @hidden="hideSub">
        <div class="list-view-drawer" v-if="itemSelected">
          <div class="list-view-drawer__header">
            <div class="list-view-drawer__title">
              <span class="list-view-drawer__code" v-if="itemSelected.points_sales">
                PEDIDO {{itemSelected.points_sales.point_sale.toString().padStart(4,'0') + '-' + itemSelected.id.toString().padStart(8,'0')}}
              </span>
              <div v-if="itemSelected.customer">{{itemSelected.customer.name}}</div>
              <div class="list-view-drawer__meta" v-if="itemSelected.date">
                {{moment(itemSelected.date).format('DD/MM/YYYY')}}
              </div>
            </div>
            <div class="list-view-drawer__nav">
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoPrevOrder"
                        v-b-tooltip.hover
                        title="Pedido anterior"
                        @click="goPrevOrder()">
                <AppIcon name="chevron-up" />
              </b-button>
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoNextOrder"
                        v-b-tooltip.hover
                        title="Pedido siguiente"
                        @click="goNextOrder()">
                <AppIcon name="chevron-down" />
              </b-button>
            </div>
          </div>

          <div class="list-view-drawer__stats">
            <div class="list-view-drawer__stat" v-if="itemSelected.status!='in_process'">
              <span class="list-view-drawer__stat-label">Total</span>
              <span class="list-view-drawer__stat-value" :class="itemSelected.paid ? 'order-total-table-paid' : 'order-total-table-nopaid'">
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.origin_currency_code}).format(filters.show_total_iva ? itemSelected.totalIva : itemSelected.total)}}
              </span>
            </div>
            <div class="list-view-drawer__stat">
              <span class="list-view-drawer__stat-label">Estado</span>
              <span class="list-view-drawer__stat-value" v-html="getStatusName(itemSelected)"></span>
            </div>
          </div>

          <div>
            <div class="list-view-drawer__section-title">
              <AppIcon name="list-ul" /> Detalle
            </div>

            <b-table  class="app-table app-table--compact"
                      responsive
                      stacked
                      :hover="true"
                      :small="true"
                      :fixed="false"
                      :items="tableSub.items"
                      :fields="tableSub.fields"
                      v-if="tableSub.items.length">

              <template v-slot:cell(quantity)="row">
                {{row.item.quantity}}
                <span v-if="row.item.unit_measurement">{{row.item.unit_measurement.reference}}</span>
              </template>

              <template v-slot:cell(product)="row">
                <div class="text-truncate" v-b-tooltip.hover :title="getProductName(row.item).replace(/<[^>]*>/g, '')" v-html="getProductName(row.item)"></div>
              </template>

            </b-table>
            <EmptyState v-else icon="list-ul" title="Sin items cargados" />
          </div>

          <b-button v-if="tableSub.items.length"
                    block
                    size="sm"
                    variant="outline-secondary"
                    class="text-left"
                    @click="openDetail()">
            <AppIcon name="visibility" class="mr-1" /> Ver detalle completo
          </b-button>
        </div>
      </b-sidebar>

      <b-row>
        <b-col lg="12">
          <b-card body-class="py-2">
            <div class="list-view-footer">
              <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
                <AppIcon name="back" />
                Volver
              </b-button>

              <nav v-if="table.tablePaginate">
                <b-pagination class="mb-0"
                              size="sm"
                              pills=""
                              :total-rows="table.tablePaginate.total"
                              :per-page="table.tablePaginate.per_page"
                              v-model="table.currentPage"
                              @input="filterOrders()" />
              </nav>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              size="xl"
              dialog-class="orders-seller-form-modal-dialog"
              :key="modal.form._id"
              :id="modal.form._id">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="edit" /></span>
          <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
        </div>

        <form-wizard  title=""
                      subtitle=""
                      nextButtonText="Siguiente"
                      backButtonText="Atrás"
                      finishButtonText="Guardar"
                      color="#2f353a"
                      shape="tab"
                      @on-complete="save"
                      class="crud-orders-wizard">

          <tab-content title="General" icon="fa fa-edit" :before-change="orderValidDetailGeneral">
            <b-row>
              <b-col md="6">
                <FindObject render="search"
                            type="customers-by-seller"
                            :extra-filter-data="{ sellers_id: sellerID }"
                            :where="conditionCustomersActive"
                            @select-object="loadCustomers($event)"
                            :valueID="crud.form.customers_id" />
              </b-col>

              <b-col md="4">
                <b-form-group label="Fecha">
                  <b-form-datepicker size="sm" v-model="crud.form.date" placeholder="Fecha" local="es"></b-form-datepicker>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <FindObject render="search"
                            type="erpPointsSales"
                            auto-select-single
                            display="full_identification"
                            @select-object="loadPointsSales($event)"
                            :valueID="crud.form.erp_points_sales_id"
                            :key="crud.form.erp_points_sales_id"
                            :showAllRegister="true" />
              </b-col>
              <b-col md="4">
                <FindObject render="search"
                            type="erpMethodsPayment"
                            auto-select-single
                            @select-object="loadMethodsPayment($event)"
                            :valueID="crud.form.methods_payment_id"
                            :key="crud.form.methods_payment_id" />
              </b-col>
              <b-col md="4" v-if="showShipping">
                <FindObject render="search"
                            type="suppliers"
                            @select-object="loadShipping($event)"
                            :where="conditionSuppliersShippingActive"
                            :valueID="crud.form.shipping_id"
                            tag="Transporte"
                            :key="crud.form.shipping_id"/>
              </b-col>

              <b-col md="4" v-if="parameters.haveReason">
                <FindObject render="search"
                            type="orders-reason"
                            @select-object="loadReason($event)"
                            :valueID="crud.form.reason_id"
                            tag="Motivos"
                            :key="crud.form.reason_id"
                            :where="conditionReason"
                            :disabled="crud.form.id>0" />
              </b-col>
            </b-row>
          </tab-content>

          <tab-content title="Productos" icon="fa fa-qrcode" :before-change="orderValidDetailItems">
            <b-row v-if="crud.form.customers_id">
              <b-col lg="12" md="12" sm="12">
                  <Detail :customer_id="crud.form.customers_id"
                          :price_list_id="crud.form.price_list_id"
                          :reason_id="crud.form.reason_id"
                          @load-detail="crud.form.detail = $event"
                          :editPrice="editPrice"
                          :validStock="validStock"
                          :showDiscount="false"
                          :key="'detailOrder_'+itemDetailForceUpdate"
                          :forceUpdate="itemDetailForceUpdate"
                          :validItemDuplicated="!allowProductsDuplicates"
                          :getItemOnlyPublished="showItemOnlyPublished" />

                    <b-row class="pl-3 pr-3 pb-2 mt-2">
                      <b-col md="2" class="mb-2 mb-md-0">
                        <div class="crud-orders-stat">
                          <span class="crud-orders-stat__label">Items</span>
                          <span class="crud-orders-stat__value">{{this.getCantItemOrder}}</span>
                        </div>
                      </b-col>
                      <b-col md="6"></b-col>
                      <b-col md="4" v-if="getCurrencyOrder">
                        <div class="crud-orders-totals">
                          <div class="crud-orders-totals__row">
                            <span class="crud-orders-totals__label">Subtotal</span>
                            <span class="crud-orders-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyOrder}).format(getSubTotalOrder)}}</span>
                          </div>
                          <div class="crud-orders-totals__row">
                            <span class="crud-orders-totals__label">{{ this.getTagDiscount }}</span>
                            <div class="crud-orders-totals__discount-group">
                              <div class="crud-orders-totals__discount">
                                <b-form-select
                                  v-if="getValueDiscount && getValueDiscount.length"
                                  v-model="crud.form.percentage_discount"
                                  :options="getValueDiscount"
                                  size="sm"
                                  @input="validDiscounts()">
                                </b-form-select>
                                <b-form-input
                                  v-if="!getValueDiscount || !getValueDiscount.length"
                                  v-model="crud.form.percentage_discount"
                                  type="number"
                                  min="0"
                                  max="100"
                                  step="1"
                                  size="sm"
                                  @change="validDiscounts()"/>
                                <span class="crud-orders-totals__discount-suffix">%</span>
                              </div>
                              <span class="crud-orders-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyOrder}).format(crud.form.discounts_price)}}</span>
                            </div>
                          </div>
                          <div class="crud-orders-totals__row crud-orders-totals__row--total">
                            <span class="crud-orders-totals__label">Total</span>
                            <span class="crud-orders-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyOrder}).format(getTotalOrder)}}</span>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
              </b-col>
            </b-row>
          </tab-content>

          <tab-content title="Observaciones" icon="fa fa-flag-checkered">
            <b-row>
              <b-col md="6">
                <div v-if="crud.form.customers">
                  <div>
                    <b-avatar :src="crud.form.customers.image"
                              v-if="crud.form.customers.image">
                    </b-avatar>
                    <b-avatar v-else
                              :text="avatarFromName(crud.form.customers.name).text"
                              :style="avatarFromName(crud.form.customers.name).style">
                    </b-avatar>
                    &nbsp;<b>{{crud.form.customers.name}}</b>

                    <span v-if="crud.form.customers.bcra_status">
                      <span v-if="crud.form.customers.bcra_status.situacion > situationCreditMax">
                        &nbsp;
                        <b-badge variant="danger" :id="'popover-situation-' + crud.form.id">
                          Sit {{crud.form.customers.bcra_status.situacion}}
                        </b-badge>
                        <b-popover :target="'popover-situation-' + crud.form.id" variant="danger" triggers="hover">
                          <template #title>Riesgo Creditício</template>
                          <div v-html="situationCreditMessage(crud.form)"></div>
                        </b-popover>
                      </span>
                    </span>

                    <AppIcon name="circle-fill" v-if="!crud.form.customers.active" class="ml-2 text-danger" v-b-tooltip.hover title="Cliente INACTIVO" />
                  </div>

                  <div v-if="crud.form.customers" class="ml-3">
                    <div v-if="!crud.form.customers.email">
                      <AppIcon name="mail" /> &nbsp;&nbsp;
                      <b-badge variant="warning" class="badget-custom">No tiene un email asociado</b-badge>
                    </div>
                    <div v-else>
                      <AppIcon name="mail" /> &nbsp;&nbsp;
                      <b-link :href="'mailto:' + crud.form.customers.email">
                        {{ crud.form.customers.email }}
                      </b-link>
                    </div>
                  </div>

                  <div v-if="crud.form.customers.phone" class="ml-3">
                    <AppIcon name="call" /> &nbsp;&nbsp;
                    <b-link :href="'tel:' + crud.form.customers.phone">
                      {{ crud.form.customers.phone }}
                    </b-link>
                  </div>

                  <b-row v-if="crud.form.customers.observations || crud.form.customers.observations_delivery || crud.form.customers.observations_delivery_address">
                    <b-col>
                      <hr>
                    </b-col>
                  </b-row>

                  <b-row v-if="crud.form.customers.observations"  class="mt-2">
                    <b-col class="crud-orders-observations">
                      <b>Observaciones</b>
                      <br>
                      {{ crud.form.customers.observations }}
                    </b-col>
                  </b-row>
                  <b-row v-if="crud.form.customers.observations_delivery"  class="mt-2">
                    <b-col class="crud-orders-observations">
                      <b>Transporte</b>
                      <br>
                      {{ crud.form.customers.observations_delivery }}
                    </b-col>
                  </b-row>
                  <b-row v-if="crud.form.customers.observations_delivery_address" class="mt-2">
                    <b-col class="crud-orders-observations">
                      <b>Dirección de Entrega</b>
                      <br>
                      {{ crud.form.customers.observations_delivery_address }}
                    </b-col>
                  </b-row>
                </div>

                <b-row>
                  <b-col md="12">
                    <hr class="mt-2 mb-2">
                  </b-col>
                  <b-col md="12">
                    <b-form-group label="Email Alternativo" description="Este email se agrega a la lista de receptores del cliente para este pedido">
                      <b-form-input type="text"
                                    size="sm"
                                    v-model="crud.form.email_alternative"
                                    lazy
                                    required
                                    placeholder="Ingresar un email alternativo">
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>

              <b-col md="6">
                <b-row>
                  <b-col md="12">
                    <b-form-group label="Observaciones">
                      <app-textarea
                        v-model="crud.form.observations"
                        placeholder="Ingresar las observaciones..."
                        rows="5"
                        max-rows="7"
                        lazy
                      ></app-textarea>
                    </b-form-group>
                  </b-col>

                  <b-col md="12" class="mt-2">
                    <b-form-group label="Observaciones Internas (No se muestra al cliente)">
                      <app-textarea
                        v-model="crud.form.observations_internal"
                        placeholder="Ingresar las observaciones internas..."
                        rows="5"
                        max-rows="7"
                        lazy
                      ></app-textarea>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </tab-content>

        </form-wizard>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="cancel()">Cancelar</b-button>
        </div>
      </b-modal>

      <!-- CRUD DETAILS -->
      <b-modal v-model="modal.detail.active"
              size="xl"
              :key="modal.detail._id"
              :id="modal.detail._id">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="visibility" /></span>
          <h5 class="app-modal-header__title">
            {{this.modal.detail.title}}
            <b-badge v-if="itemSelected" :variant="itemSelected.is_retail ? 'secondary' : 'primary'" class="ml-1">
              {{ itemSelected.is_retail ? 'Minorista' : 'Mayorista' }}
            </b-badge>
          </h5>
        </div>

        <b-row>
          <b-col sm="12">

            <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark">

              <b-tab v-if="itemSelected">
                <template #title><AppIcon name="description" class="mr-1" /> General</template>
                <div class="app-modal-detail-list">
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">ID</span>
                    <span class="app-modal-detail-list__value"><b>#{{this.itemSelected.id}}</b></span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.points_sales && itemSelected.points_sales.business">
                    <span class="app-modal-detail-list__label">Empresa</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.points_sales.business.reference}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.points_sales">
                    <span class="app-modal-detail-list__label">Número</span>
                    <span class="app-modal-detail-list__value"><b>PEDIDO {{this.itemSelected.points_sales.point_sale.toString().padStart(4,'0') + '-' + this.itemSelected.id.toString().padStart(8,'0')}}</b></span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.nro_order_internal">
                    <span class="app-modal-detail-list__label">Numeración Interna</span>
                    <span class="app-modal-detail-list__value app-modal-detail-list__value--warning">
                      <b><AppIcon name="link-45deg" /> {{this.itemSelected.nro_order_internal}}</b>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Fecha</span>
                    <span class="app-modal-detail-list__value">{{moment(this.itemSelected.date).format('DD MMMM YYYY')}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.points_sales">
                    <span class="app-modal-detail-list__label">Punto de Venta</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.points_sales.point_sale}} - {{this.itemSelected.points_sales.name}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.customer">
                    <span class="app-modal-detail-list__label">Cliente</span>
                    <span class="app-modal-detail-list__value">
                      <u>{{this.itemSelected.customer.name}}</u>
                      <div v-if="itemSelected.customer.phone">
                        <AppIcon name="call" /> {{this.itemSelected.customer.phone}}
                      </div>
                      <div v-if="itemSelected.customer.email">
                        <AppIcon name="inbox" /> {{this.itemSelected.customer.email}}
                      </div>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.user">
                    <span class="app-modal-detail-list__label">Usuario</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.user.name}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.reason">
                    <span class="app-modal-detail-list__label">Motivo</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.reason.name}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.method_payment">
                    <span class="app-modal-detail-list__label">Método de Pago</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.method_payment.name}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.shipping">
                    <span class="app-modal-detail-list__label">Transporte</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.shipping.name}}</span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Estado</span>
                    <span class="app-modal-detail-list__value">
                      <span v-html="getStatusName(itemSelected)"></span>
                      <span v-if="itemSelected.status_system_manufacture" style="font-size: 10px;" class="ml-1">
                        <span v-if="JSON.parse(itemSelected.status_system_manufacture).status == 'ok'" class="text-info">
                          <i>({{JSON.parse(itemSelected.status_system_manufacture).message}})</i>
                        </span>
                        <span v-if="JSON.parse(itemSelected.status_system_manufacture).status == 'error'" class="text-danger">
                          <i>{{JSON.parse(itemSelected.status_system_manufacture).message}}</i>
                        </span>
                      </span>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.status!='in_process'">
                    <span class="app-modal-detail-list__label">SubTotal</span>
                    <span class="app-modal-detail-list__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.origin_currency_code}).format(this.subtotalItemSelected)}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="parseFloat(itemSelected.discounts_price)">
                    <span class="app-modal-detail-list__label">{{ this.getTagDiscount }}</span>
                    <span class="app-modal-detail-list__value app-modal-detail-list__value--warning">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.origin_currency_code}).format(this.itemSelected.discounts_price)}}
                      <span v-if="parseFloat(itemSelected.percentage_discount)>0">
                        ({{parseFloat(this.itemSelected.percentage_discount)}} %)
                      </span>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.delivery_info">
                    <span class="app-modal-detail-list__label">Entrega</span>
                    <span class="app-modal-detail-list__value">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.origin_currency_code}).format(this.itemSelected.delivery_price)}}
                      <div>{{this.itemSelected.delivery_info}}</div>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Total S/IVA</span>
                    <span class="app-modal-detail-list__value" :class="itemSelected.paid ? 'order-total-table-paid' : 'order-total-table-nopaid'">
                      <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.origin_currency_code}).format(this.itemSelected.total)}}</b>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.status!='in_process'">
                    <span class="app-modal-detail-list__label">IVA</span>
                    <span class="app-modal-detail-list__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.origin_currency_code}).format(this.itemSelected.iva)}}</span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Total C/IVA</span>
                    <span class="app-modal-detail-list__value" :class="itemSelected.paid ? 'order-total-table-paid' : 'order-total-table-nopaid'">
                      <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.origin_currency_code}).format(this.itemSelected.totalIva)}}</b>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.street_address">
                    <span class="app-modal-detail-list__label">Dirección</span>
                    <span class="app-modal-detail-list__value">
                      {{this.itemSelected.street_address}} {{this.itemSelected.street_number}} {{this.itemSelected.apartament_floor}}
                      <br>
                      {{this.itemSelected.city}} {{this.itemSelected.province}}
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.observation">
                    <span class="app-modal-detail-list__label">Observaciones Entrega</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.observation}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.observations_internal">
                    <span class="app-modal-detail-list__label">Observaciones Internas</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.observations_internal}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.observations_external">
                    <span class="app-modal-detail-list__label">Observaciones External</span>
                    <span class="app-modal-detail-list__value"><div v-html="itemSelected.observations_external"></div></span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.paid_info">
                    <span class="app-modal-detail-list__label">Observaciones Pago</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.paid_info}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.delivery_code_tracking">
                    <span class="app-modal-detail-list__label">Observaciones Transporte</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.delivery_code_tracking}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.sale && itemSelected.sale.type_voucher && itemSelected.sale.point_sale">
                    <span class="app-modal-detail-list__label">Factura</span>
                    <span class="app-modal-detail-list__value"><b>{{this.itemSelected.sale.type_voucher.name + ' ' + this.itemSelected.sale.point_sale.point_sale.toString().padStart(4,'0') + '-' + this.itemSelected.sale.number.toString().padStart(8,'0')}}</b></span>
                  </div>
                </div>
              </b-tab>
              <b-tab title="Consumidor Final" v-if="itemSelected && itemSelected.consumer">
                <div class="app-modal-detail-list">
                  <div class="app-modal-detail-list__row" v-if="JSON.parse(itemSelected.consumer) && JSON.parse(itemSelected.consumer).name && JSON.parse(itemSelected.consumer).lastname">
                    <span class="app-modal-detail-list__label">Nombre y Apellido</span>
                    <span class="app-modal-detail-list__value">{{JSON.parse(itemSelected.consumer).name}} {{JSON.parse(itemSelected.consumer).lastname}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="JSON.parse(itemSelected.consumer) && JSON.parse(itemSelected.consumer).phone">
                    <span class="app-modal-detail-list__label">Teléfono</span>
                    <span class="app-modal-detail-list__value"><AppIcon name="call" /> {{JSON.parse(itemSelected.consumer).phone}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="JSON.parse(itemSelected.consumer) && JSON.parse(itemSelected.consumer).email">
                    <span class="app-modal-detail-list__label">Email</span>
                    <span class="app-modal-detail-list__value">{{JSON.parse(itemSelected.consumer).email}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="JSON.parse(itemSelected.consumer) && JSON.parse(itemSelected.consumer).address">
                    <span class="app-modal-detail-list__label">Dirección</span>
                    <span class="app-modal-detail-list__value">{{JSON.parse(itemSelected.consumer).address}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="JSON.parse(itemSelected.consumer) && JSON.parse(itemSelected.consumer).city">
                    <span class="app-modal-detail-list__label">Ciudad</span>
                    <span class="app-modal-detail-list__value">{{JSON.parse(itemSelected.consumer).city}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="JSON.parse(itemSelected.consumer) && JSON.parse(itemSelected.consumer).province">
                    <span class="app-modal-detail-list__label">Provincia</span>
                    <span class="app-modal-detail-list__value">{{JSON.parse(itemSelected.consumer).province}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="JSON.parse(itemSelected.consumer) && JSON.parse(itemSelected.consumer).observations">
                    <span class="app-modal-detail-list__label">Observaciones</span>
                    <span class="app-modal-detail-list__value">{{JSON.parse(itemSelected.consumer).observations}}</span>
                  </div>
                </div>
              </b-tab>
              <b-tab>
                <template #title><AppIcon name="list-ul" class="mr-1" /> Items</template>
                <b-table class="mb-0 app-table app-table--compact"
                        responsive
                        :stacked="isMobileViewport ? 'md' : false"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="tableDetail.items"
                        :fields="tableDetail.fields"
                        v-if="tableDetail.items.length">

                  <template v-slot:table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"
                      :key="field.key"
                      :style="{ width: field.width }"
                    >
                  </template>

                  <template v-slot:cell(code)="data">
                    <div v-html="getProductCode(data.item)"></div>
                  </template>

                  <template v-slot:cell(product)="data">
                    <div v-html="getProductName(data.item)"></div>
                  </template>

                  <template v-slot:cell(list)="data">
                    <span v-if="data.item.price_list">
                      {{data.item.price_list.reference}}
                    </span>
                    <span v-else>
                      <span v-if="itemSelected.price_list">
                        {{itemSelected.price_list.reference}}
                      </span>
                    </span>
                  </template>

                  <template v-slot:cell(quantity)="data">
                    <div  v-if="data.item.observations">

                        <div  :id="'tooltip-button-show-event-' + data.item.id"
                              class="text-info">
                          <b>{{data.item.quantity}}</b>
                          <span v-if="data.item.unit_measurement">{{data.item.unit_measurement.reference}}</span>
                        </div>

                        <b-tooltip  ref="tooltip"
                                    placement="left"
                                    :target="'tooltip-button-show-event-' + data.item.id">
                          <div v-html="getQuantityVariant(data.item)"></div>
                        </b-tooltip>

                    </div>
                    <div v-else>
                      {{data.item.quantity}}
                      <span v-if="data.item.unit_measurement">{{data.item.unit_measurement.reference}}</span>
                    </div>
                  </template>

                  <template v-slot:cell(unit_price)="data">
                    <div v-if="data.item.status!='in_process'">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.origin_currency_code}).format(data.item.unit_price)}}
                    </div>
                  </template>

                  <template v-slot:cell(discount_percentage)="data">
                    <div v-if="data.item.status!='in_process' && data.item.discount_percentage && parseFloat(data.item.discount_percentage) > 0">
                      {{parseFloat(data.item.discount_percentage)}}%
                    </div>
                  </template>

                  <template v-slot:cell(total)="data">
                    <div v-if="data.item.status!='in_process'">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.origin_currency_code}).format(data.item.total)}}
                    </div>
                  </template>

                 <template v-slot:cell(iva)="data">
                    <div v-if="data.item.status!='in_process'">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.origin_currency_code}).format(data.item.amount_iva)}}
                    </div>
                  </template>

                  <template v-slot:cell(total_iva)="data">
                    <div v-if="data.item.status!='in_process'">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.origin_currency_code}).format(data.item.total_iva)}}
                    </div>
                  </template>
                </b-table>
                <EmptyState v-else icon="list-ul" title="No se encontraron registros" />
              </b-tab>
            </b-tabs>

          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.detail.active=false"><AppIcon name="x" class="mr-1" />Cerrar</b-button>
        </div>
      </b-modal>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import ErrorToken from '@/handler/errorToken'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import FindObject from '@/components/inc/find/findObject'
  import Detail from '@/components/inc/cpbtDetail/detailProducts'
  import Param from '@/config/parameters'
  import moment from 'moment'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import Storage from '@/handler/storageSession'
  import StorageLocal from '@/handler/storageLocal'
  import Metrics from '@/components/inc/metrics/metrics'
  import LocationTracker from '@/handler/locationTracker'
  import Funciones from '@/handler/funciones'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      FindObject,
      FormWizard,
      TabContent,
      Detail,
      Metrics,
      TabHeaderActions,
    },
    data: () => {
      return {
        access: {
          module_id: Modules.PEDIDOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudOrdersSeller',
          elements: {}
        },
        configSubView: {
          module_id: Modules.PEDIDOS,
          profile_id: Profiles.PERSONAL,
          elements: {
            mobile_order_create: true,
          }
        },
        parameters: {
          haveNroInteral: Helper.hasParametersAccess(Param.P21),
          multipleItems: Helper.hasParametersAccess(Param.P52),
          haveReason: Helper.hasParametersAccess(Param.P54),
        },
        table : {
          items: [],
          fields: [],
          filter: null,
          currentPage: 1,
          perPage: 0,
          isBusy: false,
          tablePaginate: null,
        },
        tableSub : {
          items: [],
          fields: []
        },
        tableDetail : {
          items: [],
          fields: []
        },
        crud: {
          form: {
            id: 0,
            date: '',
            observations: '',
            staff_id: 0,
            sellers_id: 0,
            customers_id: 0,
            customers: null,
            price_list_id: 0,
            price_list: null,
            observations_internal: '',
            erp_points_sales_id: 0,
            erp_points_sales: null,
            methods_payment_id: 0,
            methods_payment: null,
            detail: [],
            email_alternative: '',
            shipping_id: 0,
            shipping: null,
            discounts_price: 0,
            percentage_discount: 0,
            is_retail: false,
            reason: null,
            reason_id : 0,
          },
        },
        modal: {
          form: {
            active: false,
            title: '',
          },
          detail: {
            active: false,
            title: '',
          },
        },
        arr: {
          orders: [],
          export: [],
          filters : {
            customers: [],
            sellers: [],
            status: [],
            points_sales: [],
            invoiced: [
              {code: true, label: 'Facturado'},
              {code: false, label: 'Sin facturar'}
            ],
            reasons: [],
          },
        },
        filters: {
          date_start: '',
          date_end: '',
          customers: null,
          sellers: null,
          status: null,
          source: 'product',
          points_sales: null,
          invoiced: null,
          typeOperations: 'wholesaler',
          number: '',
          reason: null,
          show_total_iva: false,
        },
        itemSelected: null,
        detailDrawer: false,
        // Panel de filtros: cerrado por default; el usuario que lo abre queda
        // con su preferencia persistida (ver watcher filtersOpen).
        filtersOpen: false,
        // stacked (modo card mobile) y sticky-header son mutuamente
        // excluyentes en BootstrapVue — stacked solo se activa cuando el
        // viewport realmente está en mobile (ver mounted/mobileMql).
        isMobileViewport: false,
        configurations: null,
        itemDetailForceUpdate: 0,
        itemFilterForceUpdate: 0,
        preloadedCustomerId: null,
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      this.configSubView.elements.mobile_order_create = Helper.showAccessView(this.configSubView, 'mobileOrderCreate')
      /* Fin configuracion */
    },
    mounted() {
      this.preloadedCustomerId = Number(this.$route.query.customer_id) || null
      this.loadFieldTable()
      this.filterLoad()
      this.filterOrders()
      this.loadConfigurations()

      this.filtersOpen = StorageLocal.getValue('filters_open_crud_orders_sellers') == 'true'

      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)

      this._start = true
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    activated() {
      if(this._start) {
        this._start = false
        return false
      }

      this.loadConfigurations()
      this.filterLoad()
      this.filterOrders()
    },
    watch: {
      filtersOpen: function (value) {
        StorageLocal.setValue('filters_open_crud_orders_sellers', value ? 'true' : 'false')
      },
      isMobileViewport() {
        this.loadFieldTable()
      },
      'crud.form.customers_id': function (newQuestion, oldQuestion) {
        if(!newQuestion) return
        var result = serviceAPI.mostrarCliente(newQuestion)
        result.then((response) => {
          var object = response.data

          if(object) {
            this.crud.form.customers = object

            if(!this.crud.form.observations && !this.crud.form.id) {
              if(object.observations_delivery_address) {
                this.crud.form.observations = 'ENTREGA: ' + object.observations_delivery_address
              }
            }

            if(object.data_fiscal) {
              if(object.data_fiscal.points_sales_id) {
                if(!this.crud.form.erp_points_sales_id) {
                  this.crud.form.erp_points_sales = object.data_fiscal.points_sales
                  this.crud.form.erp_points_sales_id = object.data_fiscal.points_sales_id
                }
              }
              if(object.data_fiscal.methods_payment_id) {
                if(!this.crud.form.methods_payment_id) {
                  this.crud.form.methods_payment = object.data_fiscal.methods_payment
                  this.crud.form.methods_payment_id = object.data_fiscal.methods_payment_id
                }
              }
              if(object.data_fiscal.shipping_id) {
                if(!this.crud.form.shipping_id) {
                  this.crud.form.shipping = object.data_fiscal.shipping
                  this.crud.form.shipping_id = object.data_fiscal.shipping_id
                }
              }
            }

            if(!this.crud.form.price_list_id) {
              if(object.price_list) {
                if(object.price_list.list) {
                  this.crud.form.price_list = object.price_list.list
                  this.crud.form.price_list_id = object.price_list.list.id
                }
              }
            }

            if(this.parameters.haveReason) {
              this.crud.form.reason = null
              this.crud.form.reason_id = 0
            }
          }
        })
      }
    },
    computed: {
      sellerID() { return Helper.getSeller().id },
      // NAVEGACION DEL DRAWER (anterior/siguiente sobre las filas cargadas)
      currentOrderIndex() {
        if(!this.itemSelected || !this.table.items) {
          return -1
        }
        return this.table.items.findIndex(item => item.id === this.itemSelected.id)
      },
      canGoPrevOrder() {
        return this.currentOrderIndex > 0
      },
      canGoNextOrder() {
        if(this.currentOrderIndex < 0) {
          return false
        }
        return this.currentOrderIndex < (this.table.items.length - 1)
      },

      moduleSalesActive() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules
        modules.forEach(element => {
          if(element.id == Modules.VENTAS) {
            status = true
          }
        })
        return status
      },
      // OTHERS
      subtotalItemSelected() {
        if(this.getAplicationDiscount) {
          if(this.itemSelected) {
            return parseFloat(this.itemSelected.total) - parseFloat(this.itemSelected.delivery_price)
          } else {
            return 0
          }
        } else {
          if(this.itemSelected) {
            return parseFloat(this.itemSelected.total) - parseFloat(this.itemSelected.delivery_price) + parseFloat(this.itemSelected.discounts_price)
          } else {
            return 0
          }
        }
      },
      situationCreditMax() {
        if(this.configurations) {
          return this.configurations[1].value_number;
        } else {
          return 0;
        }
      },

      // CONDITIONS SELECT
      conditionCustomersActive(){
        return [{field: 'active', condition: true}];
      },
      conditionSuppliersShippingActive(){
        var condition = []
        condition.push({field: 'active', condition: true})
        condition.push({field: 'shipping', condition: true})
        return condition;
      },
      conditionReason() {
        let condition = []
        if(this.crud.form.customers_id && this.crud.form.customers_id["code"]) {
          condition.push({field: 'customer', condition: this.crud.form.customers_id["code"]});
        }
        return condition
      },

      // DISCOUNTS
      getTagDiscount() {
        if(this.configurations && this.configurations[19].value_string) {
          return this.configurations[19].value_string
        } else {
          return 'Descuento'
        }
      },
      getValueDiscount(){
        if(this.configurations && this.configurations[20].value_string) {
          var value = JSON.parse(this.configurations[20].value_string)
          var arr = []
          value.forEach(element => {
            arr.push({
              value:element,
              text: element + ' %'
            })
          });
          return arr
        } else {
          return null
        }
      },
      getAplicationDiscount() {
        if(this.configurations) {
          if(this.configurations[21].value_boolean == 1) {
            return true
          } else {
            return false
          }
        } else {
          return false;
        }
      },

      // CONFIG DETAIL
      validStock() {
        if(this.configurations) {
          if(this.configurations[2].value_boolean == 1) {
            return false
          } else {
            return true
          }
        } else {
          return true;
        }
      },
      editPrice() {
        if(this.configurations) {
          if(this.configurations[3].value_boolean == 1) {
            return true
          } else {
            return false
          }
        } else {
          return false;
        }
      },
      allowProductsDuplicates() {
        if(this.configurations) {
          if(this.configurations[16].value_boolean == 1) {
            return true
          } else {
            if(this.parameters.multipleItems) {
              return true
            } else {
              return false
            }
          }
        } else {
          if(this.parameters.multipleItems) {
            return true
          } else {
            return false
          }
        }
      },
      showItemOnlyPublished() {
        var status = this.crud.form.reason && this.crud.form.reason.only_published
        return status
      },

      // PRICES / CANT / CURRENCY
      getSubTotalOrder() {
        var price = 0
        if(this.crud.form.detail) {
          this.crud.form.detail.forEach(element => {
            price = price + parseFloat(element.quantity) * parseFloat(element.amount)
          })
        }
        return parseFloat(price)
      },
      getTotalOrder() {
        if(this.getAplicationDiscount) {
          return this.getSubTotalOrder
        } else {
          this.validDiscounts()
          var discounts_price = parseFloat(this.crud.form.discounts_price)

          return this.getSubTotalOrder - discounts_price
        }
      },
      getCantItemOrder() {
        var cant = this.crud.form.detail.length
        return parseFloat(cant)
      },
      getCurrencyOrder() {
        var currency = 'ARS'
        if(this.crud.form.detail.length) {
          currency = this.crud.form.detail[0].product.list.currency.code
        }
        return currency
      },

      // VALIDA TRANSPORTE
      showShipping() {
        if(this.configurations) {
          if(this.configurations[18].value_boolean == 1) {
            return true
          } else {
            return false
          }
        } else {
          return false;
        }
      },
      validShipping() {
        if(this.configurations) {
          if(this.configurations[17].value_boolean == 1) {
            return true
          } else {
            return false
          }
        } else {
          return false;
        }
      },
    },
    methods: {
      // RESPONSIVE
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      avatarFromName(name) {
        return Funciones.avatarFromName(name)
      },
      // Confirm estándar: header con ícono + tinte suave (.app-confirm-header)
      // en vez de header-bg-variant sólido, size 'sm' siempre, y
      // okVariant/headerClass según sea o no destructiva.
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      // Click en la fila abre el drawer de detalle, salvo que el click haya
      // sido sobre un control (un link, etc.).
      onRowClicked(item, index, event) {
        if(!item) return

        if(event && event.target) {
          const ignoreTags = ['INPUT', 'BUTTON', 'A', 'SELECT', 'TEXTAREA', 'LABEL', 'SVG', 'PATH']
          if(ignoreTags.includes(event.target.tagName)) return
          if(event.target.closest('.dropdown')) return
        }

        this.openSub(item)
      },
      // Resalta en la tabla la fila del registro que está abierto en el
      // drawer, para no perder la referencia visual mientras se navega con
      // los botones anterior/siguiente.
      rowClass(item, type) {
        if(type !== 'row' || !item) return ''
        if(this.detailDrawer && this.itemSelected && item.id === this.itemSelected.id) {
          return 'app-table-row-active'
        }
        return ''
      },

      // CONFIGURACION
      loadFieldTable () {
        // TABLE PEDIDOS
        this.table.fields = []
        this.table.fields.push({key: 'business', label: 'Empresa', class:"align-middle " + this.alignClass('text-left'), width:"50px"})
        this.table.fields.push({key: 'id', label: 'Nº', sortable: true, class:"align-middle " + this.alignClass('text-center'), width:"70px"})
        this.table.fields.push({key: 'date', label: 'Fecha', class:"align-middle " + this.alignClass('text-center'), width:"70px"})
        this.table.fields.push({key: 'customers_id', label: 'Cliente', class:"align-middle", width:"140px"})
        if(this.filters.show_total_iva) {
          this.table.fields.push({key: 'total', label: 'Total C/IVA', class:"align-middle " + this.alignClass('text-right'), width:"90px"})
        } else {
          this.table.fields.push({key: 'total', label: 'Total S/IVA', class:"align-middle " + this.alignClass('text-right'), width:"90px"})
        }
        this.table.fields.push({key: 'status', label: 'Estado', class:"align-middle " + this.alignClass('text-center'), width:"120px"})
        if(this.parameters.haveReason) {
          this.table.fields.push({key: 'reason', label: 'Motivo', class:"align-middle " + this.alignClass('text-center'), width:"40px"})
        }
        this.table.fields.push({key: 'status_system_manufacture', label: '', class:"align-middle " + this.alignClass('text-center'), width:"10px"})
        this.table.fields.push({key: 'paid_info', label: this.isMobileViewport ? 'Pago' : '', class:"align-middle " + this.alignClass('text-center'), width:"25px"})
        this.table.fields.push({key: 'observations', label: this.isMobileViewport ? 'Observaciones' : '', class:"align-middle " + this.alignClass('text-center'), width:"25px"})
        this.table.fields.push({key: 'delivery_code_tracking', label: this.isMobileViewport ? 'Transporte' : '', class:"align-middle " + this.alignClass('text-center'), width:"25px"})
        this.table.fields.push({key: 'invoice', label: this.isMobileViewport ? 'Facturado' : '', class:"align-middle " + this.alignClass('text-center'), width:"25px"})

        // TABLE DETALLE (drawer, siempre vertical: alineación fija a la
        // izquierda, el b-sidebar tiene un ancho fijo que no depende de isMobileViewport)
        this.tableSub.fields = []
        this.tableSub.fields.push({key: 'quantity', label: 'Cantidad', class:"align-middle text-left", width:"30%"})
        this.tableSub.fields.push({key: 'product', label: 'Producto', class:"align-middle text-left", width:"70%"})

        // TABLE DETALLE COMPLETO (modal de detalle, sí depende del ancho real de la ventana)
        this.tableDetail.fields = []
        this.tableDetail.fields.push({key: 'code', label: 'Código', class:"align-middle " + this.alignClass('text-left'), width:"70px"})
        this.tableDetail.fields.push({key: 'product', label: 'Producto', class:"align-middle " + this.alignClass('text-left') + " text-truncate", width:"220px"})
        this.tableDetail.fields.push({key: 'list', label: 'Lista', class:"align-middle " + this.alignClass('text-left') + " text-truncate", width:"60px"})
        this.tableDetail.fields.push({key: 'quantity', label: 'Cantidad', class:"align-middle " + this.alignClass('text-right'), width:"90px"})
        this.tableDetail.fields.push({key: 'unit_price', label: 'P.Unit', class:"align-middle " + this.alignClass('text-right'), width:"90px"})
        this.tableDetail.fields.push({key: 'discount_percentage', label: 'Desc. %', class:"align-middle " + this.alignClass('text-right'), width:"70px"})
        this.tableDetail.fields.push({key: 'total', label: 'Total S/IVA', class:"align-middle " + this.alignClass('text-right'), width:"80px"})
        this.tableDetail.fields.push({key: 'iva', label: 'IVA', class:"align-middle " + this.alignClass('text-right'), width:"80px"})
        this.tableDetail.fields.push({key: 'total_iva', label: 'Total C/IVA', class:"align-middle " + this.alignClass('text-right'), width:"80px"})
      },
      loadConfigurations() {
        var result = serviceAPI.obtenerConfiguracion()

        result.then((response) => {
          var data = response.data
          this.configurations = data

          this.setStatusAltFilter()
        })
      },
      getRowCount (items) {
        return items.length
      },

      // SELECT
      loadCustomers (object) {
        if(object){
          this.crud.form.customers = object
          this.crud.form.customers_id = object.id

          if(object.data_fiscal) {
            if(object.data_fiscal.erp_points_sales_id) {
              if(!this.crud.form.erp_points_sales_id) {
                this.crud.form.erp_points_sales = object.data_fiscal.points_sales
                this.crud.form.erp_points_sales_id = object.data_fiscal.erp_points_sales_id
              }
            }
          }
        } else {
          this.crud.form.customers = null
          this.crud.form.customers_id = 0
        }
      },
      loadPointsSales (object) {
        if(object){
          this.crud.form.erp_points_sales = object
          this.crud.form.erp_points_sales_id = object.id
        } else {
          this.crud.form.erp_points_sales = null
          this.crud.form.erp_points_sales_id = 0
        }
      },
      loadMethodsPayment (object) {
        if(object){
          this.crud.form.methods_payment = object
          this.crud.form.methods_payment_id = object.id
        } else {
          this.crud.form.methods_payment = null
          this.crud.form.methods_payment_id = 0
        }
      },
      loadShipping (object) {
        if(object){
          this.crud.form.shipping = object
          this.crud.form.shipping_id = object.id
        } else {
          this.crud.form.shipping = null
          this.crud.form.shipping_id = 0
        }
      },
      loadReason (object) {
        if(object){
          this.crud.form.reason = object
          this.crud.form.reason_id = object.id

          if(object && object.price_list_id && object.list) {
            this.crud.form.price_list = object.list
            this.crud.form.price_list_id = object.list.id
          } else {
            if(this.crud.form.customers && this.crud.form.customers.price_list && this.crud.form.customers.price_list.list) {
              this.crud.form.price_list = this.crud.form.customers.price_list.list
              this.crud.form.price_list_id = this.crud.form.customers.price_list.list.id
            }
          }
        } else {
          this.crud.form.reason = null
          this.crud.form.reason_id = 0
        }

        this.detailForceUpdate()
      },
      prepareExport(data) {
        this.arr.export = []
        data.forEach(element => {
          var businessID = 0
          var businessName = ""
          var customersID = 0
          var customersCode = ""
          var customersName = ""
          var pointSalesCode = ""
          var pointSalesName = ""
          var methodsPaymentID = 0
          var methodsPaymentName = ""
          var shippingID = 0
          var shippingName = ""
          var reasonID = 0
          var reasonName = ""

          if(element.points_sales && element.points_sales.business) {
            businessID = element.points_sales.business.id
            businessName = element.points_sales.business.reference
          }

          if(element.customer) {
            customersID = element.customer.id
            customersCode = element.customer.code
            customersName = element.customer.name
          }

          if(element.points_sales) {
            pointSalesCode = element.points_sales.point_sale
            pointSalesName = element.points_sales.name
          }

          if(element.method_payment) {
            methodsPaymentID = element.method_payment.id
            methodsPaymentName = element.method_payment.name
          }

          if(element.shipping) {
            shippingID = element.shipping.id
            shippingName = element.shipping.name
          }

          if(element.reason) {
            reasonID = element.reason.id
            reasonName = element.reason.name
          }

          this.arr.export.push({
            id: element.id,
            businessID: businessID,
            businessName: businessName,
            pointSalesCode: pointSalesCode,
            pointSalesName: pointSalesName,
            date: element.date,
            customersID: customersID,
            customersCode: customersCode,
            customersName: customersName,
            methodsPaymentID: methodsPaymentID,
            methodsPaymentName: methodsPaymentName,
            shippingID: shippingID,
            shippingName: shippingName,
            reasonID: reasonID,
            reasonName: reasonName,
            discount: element.discounts_price.replace('.',','),
            percentage_discount: element.percentage_discount.replace('.',','),
            total: element.total.replace('.',','),
            status: this.getStatusAltByName(element),
            observations: element.observation,
            observations_external: element.observations_external,
            productID: 0,
            productCode: '',
            productName: '',
            priceListID: 0,
            priceListName: "",
            quantity: 0,
            unitMeasurementID: 0,
            unitMeasurementName: '',
            unit_price: 0,
            amount_total: 0,
          })

          element.details.forEach(element1 => {
            var productID = 0
            var productCode = ""
            var productName = ""
            var unitMeasurementID = 0
            var unitMeasurementName = ""
            var priceListID = 0
            var priceListName = ""

            if(element1.products_id && element1.product) {
              productID = element1.product.id
              productCode = element1.product.code
              productName = element1.product.name
            }

            if(element1.products_colors_id && element1.products_color) {
              productID = element1.products_color.id
              productCode = element1.products_color.code
              productName = element1.products_color.name + " (" + element1.products_color.color.name + ")"
            }

            if(element1.products_waist_id && element1.products_waist) {
              productID = element1.products_waist.id
              productCode = element1.products_waist.code
              productName = element1.products_waist.name + " (" + element1.products_waist.waist.name + ")"
            }

            if(element1.products_color_waist_id && element1.products_color_waist) {
              productID = element1.products_color_waist.id
              productCode = element1.products_color_waist.code
              productName = element1.products_color_waist.name + " (" + element1.products_color_waist.color.name + " - " + element1.products_color_waist.waist.name + ")"
            }

            if(element1.unit_measurement_id && element1.unit_measurement) {
              unitMeasurementID = element1.unit_measurement.id
              unitMeasurementName = element1.unit_measurement.name
            }

            if(element1.price_list_id && element1.price_list) {
              priceListID = element1.price_list.id
              priceListName = element1.price_list.name
            } else {
              if(element.price_list_id && element.price_list) {
                priceListID = element.price_list.id
                priceListName = element.price_list.name
              }
            }

            this.arr.export.push({
              productID: productID,
              productCode: productCode,
              productName: productName,
              priceListID: priceListID,
              priceListName: priceListName,
              quantity: element1.quantity.replace('.',','),
              unitMeasurementID: unitMeasurementID,
              unitMeasurementName: unitMeasurementName,
              unit_price: element1.unit_price.replace('.',','),
              amount_total: element1.total.replace('.',','),
            })
          })
        });
      },

      // ABM MAIN
      openMobileOrderCreate() {
        this.$router.push({ name: 'OrdersStaffMobileOrderCreate' })
      },
      add() {
        this.crud.form.id = 0
        this.crud.form.date = moment().format('YYYY-MM-DD')
        this.crud.form.observations = ''
        this.crud.form.staff_id = Helper.getStaffId()
        this.crud.form.sellers_id = 0
        this.crud.form.customers_id = 0
        this.crud.form.customers = null
        this.crud.form.price_list_id = 0
        this.crud.form.price_list = null
        this.crud.form.observations_internal = ''
        this.crud.form.erp_points_sales_id = 0
        this.crud.form.erp_points_sales = null
        this.crud.form.methods_payment_id = 0
        this.crud.form.methods_payment = null
        this.crud.form.detail = []
        this.crud.form.email_alternative = ''
        this.crud.form.shipping_id = 0
        this.crud.form.shipping = null
        this.crud.form.discounts_price = 0
        this.crud.form.percentage_discount = 0
        this.crud.form.is_retail = false
        this.crud.form.reason_id = 0
        this.crud.form.reason = null

        this.detailForceUpdate()

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nuevo Pedido"
        this.modal.form.active = true
      },
      openPreloadedOrder() {
        if(!this.preloadedCustomerId) return

        this.add()
        this.crud.form.customers_id = this.preloadedCustomerId
        this.preloadedCustomerId = null
        this.modal.form._id = Math.random().toString(36).slice(2, 8)
      },
      save() {
        if(!this.crud.form.erp_points_sales_id) {
          this.$awn.alert('Falta cargar el punto de venta')
          return false
        }

        this.confirmDialog('¿Desea continuar con la generación del pedido?', {
          title: 'Generar Pedido',
          okTitle: 'GENERAR'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var result = serviceAPI.agregarPedido(this.crud.form);

            result.then((response) => {
              this.modal.form.active = false
              loader.hide()
              this.filterOrders()
              if(response && response.data && response.data.id) {
                LocationTracker.send({ order_id: response.data.id, source: 'order' })
              }
              this.$awn.success("Pedido generado con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      cancel() {
        this.confirmDialog('¿Desea cancelar el pedido?', {
          title: 'Cancelar el Pedido',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            this.modal.form.active = false
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      orderValidDetailGeneral() {
        var valid = this.crud.form.customers_id && this.crud.form.erp_points_sales_id && this.crud.form.methods_payment_id

        if(this.validShipping) {
          valid = valid && this.crud.form.shipping_id
        }

        if(this.parameters.haveReason) {
          valid = valid && this.crud.form.reason_id
        }

        if(valid) {
          return true;
        } else {
          if(!this.crud.form.customers_id) {
            this.$awn.alert("No se cargó el cliente");
            return false;
          }
          if(!this.crud.form.erp_points_sales_id) {
            this.$awn.alert("No se cargó el punto de venta");
            return false;
          }
          if(!this.crud.form.methods_payment_id) {
            this.$awn.alert("No se cargó el método de pago");
            return false;
          }
          if(this.validShipping) {
            if(!this.crud.form.shipping_id) {
              this.$awn.alert("No se cargó el transporte");
              return false;
            }
          }
          if(this.parameters.haveReason) {
            if(!this.crud.form.reason_id) {
              this.$awn.alert("No se cargó el motivo");
              return false;
            }
          }
        }
      },
      orderValidDetailItems() {
          if(this.crud.form.detail.length) {
            return true;
          } else {
            this.$awn.alert("No se cargó ningún item");
            return false;
          }
      },
      detailForceUpdate() {
        this.itemDetailForceUpdate = this.itemDetailForceUpdate + 1
      },
      filterForceUpdate() {
        this.itemFilterForceUpdate = this.itemFilterForceUpdate + 1
      },

      // DISCOUNTS
      validDiscounts() {
        if(this.crud.form.percentage_discount=='') {
          this.crud.form.percentage_discount = 0
        } else {
          if( parseFloat(this.crud.form.percentage_discount) < 0 ||
              parseFloat(this.crud.form.percentage_discount) > 100 ) {
            this.crud.form.percentage_discount = 0
          }
        }

        var percentage = parseFloat(this.crud.form.percentage_discount)
        this.crud.form.discounts_price = (this.getSubTotalOrder * percentage) / 100
      },

      // FILTER
      filterLoad() {
        this.filterLoadCustomers()
        this.filterLoadSellers()
        this.filterLoadPointSale()
        this.filterLoadReasons()
        this.filters.date_start = moment().subtract(30, 'days').format('YYYY-MM-DD')
        this.filters.date_end = moment().format('YYYY-MM-DD')

        this.restoreFilterStorage()
        if(!this.moduleSalesActive) {
          this.filters.invoiced = null
        }
      },
      filterLoadCustomers() {
        var result = serviceAPI.obtenerClientesByZonas({ sellers_id: Helper.getSeller().id })
        result.then((response) => {
          var data = response.data

          this.arr.filters.customers = []
          data.forEach(element => {
            if(element.code) {
              this.arr.filters.customers.push({ code: element.id, label: element.code + ' | ' + element.name })
            } else {
              this.arr.filters.customers.push({ code: element.id, label: element.name })
            }
          });

          this.openPreloadedOrder()

          if(this.customersID) {
            this.validCustomers()
          }
        })
      },
      filterLoadSellers() {
        var result = serviceAPI.obtenerVendedores()
        result.then((response) => {
          var data = response.data

          this.arr.filters.sellers = []
          data.forEach(element => {
            this.arr.filters.sellers.push({ code: element.id, label: element.name })
          });
        })
      },
      filterLoadPointSale() {
        var result = serviceAPI.obtenerPuntosVentas()
        result.then((response) => {
          var data = response.data

          this.arr.filters.points_sales = []
          data.forEach(element => {
            this.arr.filters.points_sales.push({ code: element.id, label: element.full_identification })
          });
        })
      },
      filterLoadReasons() {
        var result = serviceAPI.obtenerMotivos()
        result.then((response) => {
          var data = response.data

          this.arr.filters.reasons = []
          data.forEach(element => {
            this.arr.filters.reasons.push({ code: element.id, label: element.name })
          });
        })
      },
      filterOrders(forceOpenSub=false) {
        this.saveFilterStorage()

        this.filters.sellers = []
        this.filters.sellers.push({
          code: Helper.getSeller().id,
          label: Helper.getSeller().name,
        })

        this.table.isBusy = true
        var result = serviceAPI.filtrarPedido(this.filters, this.table.currentPage)
        result.then((response) => {
          var data = response.data
          this.table.tablePaginate = data
          this.table.items = data.data
          this.arr.orders = data.data
          this.prepareExport(data.data)

          this.table.items.forEach(element => {
            if(element.status == 'cancel') {
              element._rowVariant = 'danger'
            }

            if(forceOpenSub) {
              if(element.id == this.itemSelected.id) {
                this.openSub(element)
              }
            }
          });

          this.loadFieldTable()

          this.table.isBusy = false
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(ErrorToken.valid(error));
        })
      },
      filterOrdersMetrics() {
        this.filterForceUpdate()
      },

      // ORDER DETAIL
      openSub(item) {
        this.itemSelected = item

        this.tableSub.items = item.details
        this.detailDrawer = true
      },
      hideSub() {
        this.tableSub.items=[]
        this.itemSelected = null
        this.detailDrawer = false
      },
      // Anterior/siguiente desde el drawer: reusa openSub() con el vecino,
      // así el contenido y el resaltado de fila se actualizan por el mismo
      // camino que un click directo en la tabla.
      goPrevOrder() {
        if(!this.canGoPrevOrder) return
        var item = this.table.items[this.currentOrderIndex - 1]
        if(item) this.openSub(item)
      },
      goNextOrder() {
        if(!this.canGoNextOrder) return
        var item = this.table.items[this.currentOrderIndex + 1]
        if(item) this.openSub(item)
      },
      openDetail() {
        this.tableDetail.items = this.itemSelected.details

        this.modal.detail._id = Math.random().toString(36).slice(2, 8)
        this.modal.detail.title = "Detalle del Pedido"
        this.modal.detail.active = true
      },
      getProductCode(item) {
        var code = ''
        var prod = null

        if(item.code) {
          code = item.code
        }

        if(item.products_id) {
          if(code) {
            return code
          } else {
            return item.product.code
          }
        }

        if(item.products_colors_id) {
          prod = item.products_color
          if(code) {
            return code
          } else {
            return prod.code
          }
        }

        if(item.products_waist_id) {
          prod = item.products_waist
          if(code) {
            return code
          } else {
            return prod.code
          }
        }

        if(item.products_color_waist_id) {
          prod = item.products_color_waist
          if(code) {
            return code
          } else {
            return prod.code
          }
        }
      },
      getProductName(item) {
        var name = ''
        var prod = null

        if(item.description) {
          name = item.description
        }

        if(item.products_id) {
          if(name) {
            return name
          } else {
            return item.product.name
          }
        }

        if(item.products_colors_id) {
          prod = item.products_color
          if(name) {
            return name + ' (' + prod.color.name + ')'
          } else {
            return prod.name + ' (' + prod.color.name + ')'
          }
        }

        if(item.products_waist_id) {
          prod = item.products_waist
          if(name) {
            return name + ' (' + prod.waist.name + ')'
          } else {
            return prod.name + ' (' + prod.waist.name + ')'
          }
        }

        if(item.products_color_waist_id) {
          prod = item.products_color_waist
          if(name) {
            return name + ' (' + prod.color.name + ' - ' + prod.waist.name + ')'
          } else {
            return prod.name + ' (' + prod.color.name + ' - ' + prod.waist.name + ')'
          }
        }
      },
      getQuantityVariant(item) {
        var html = ''
        if(item.observations) {
          var variants = JSON.parse(item.observations)
          variants.forEach((element, index) => {
            var name = element[0]
            var cant = element[1]
            if(parseFloat(cant)>0) {
              html = html + '<i class="fa fa-circle" style="font-size:8px;"></i> ' + name + '- (<b>' + cant + '</b>)<br>'
            }
          });
        }
        return html
      },

      // STATUS ALTERNTIVOS
      getStatusName(item) {
        var name = ''
        var background = 'black'
        var arrStatus = item.status_alt

        switch (item.status) {
          case 'in_process':
            name = arrStatus[0]
            background = '#c1bb00'
            break;

          case 'closed':
            name = arrStatus[1]
            background = '#1a85e0'
            break;

          case 'in_preparation':
            name = arrStatus[2]
            background = '#582eda'
            break;

          case 'pending_shipping':
            name = arrStatus[3]
            background = '#ce7910'
            break;

          case 'in_transport':
            name = arrStatus[4]
            background = '#33bf8c'
            break;

          case 'delivered':
            name = arrStatus[5]
            background = '#3e9619'
            break;

          case 'cancel':
            name = arrStatus[6]
            background = '#d23829'
            break;
        }

        // system manufacture status
        if(item.status_system_manufacture && this.configurations) {
          if(JSON.parse(item.status_system_manufacture).status == 'ok') {
            name = this.configurations[11].value_string
            background = '#c72eda'
          }
          if(JSON.parse(item.status_system_manufacture).status == 'error') {
            name = this.configurations[12].value_string
            background = '#ff1f1f'
          }
        }
        // fin

        return '<span style="background-color:' + background + '; color: #fff; font-size:12px; font-weight:700; padding: 2px;">'+ name +"</span>"
      },
      getInvoiceTitle(item) {
        if(!item || !item.sale || !item.sale.type_voucher || !item.sale.point_sale) {
          return ''
        }

        var title = item.sale.type_voucher.name + ' ' + item.sale.point_sale.point_sale.toString().padStart(4,'0') + '-' + item.sale.number.toString().padStart(8,'0')
        if(item.sale.date) {
          title = title + ' | ' + moment(item.sale.date).format('DD/MM/YYYY')
        }

        return title
      },
      setStatusAltFilter() {
        var arrStatus = this.configurations[9].value_string.split(',')
        var haveSystemManufacture = this.configurations[4].value_string
        var showStatusInProcess = this.configurations[13].value_boolean

        this.arr.filters.status = []

        if(showStatusInProcess) {
          if(arrStatus[0])
            this.arr.filters.status.push({code:'in_process', label: arrStatus[0]})
        }

        if(arrStatus[1])
          this.arr.filters.status.push({code:'closed', label: arrStatus[1]})

        if(haveSystemManufacture) {
          this.arr.filters.status.push({code:'pending_manufacture', label: this.configurations[11].value_string})
          this.arr.filters.status.push({code:'error_manufacture', label: this.configurations[12].value_string})
        }

        if(arrStatus[2])
          this.arr.filters.status.push({code:'in_preparation', label: arrStatus[2]})

        if(arrStatus[3])
          this.arr.filters.status.push({code:'pending_shipping', label: arrStatus[3]})

        if(arrStatus[4])
          this.arr.filters.status.push({code:'in_transport', label: arrStatus[4]})

        if(arrStatus[5])
          this.arr.filters.status.push({code:'delivered', label: arrStatus[5]})

        if(arrStatus[6])
          this.arr.filters.status.push({code:'cancel', label: arrStatus[6]})
      },
      getStatusAltByName(item) {
        var name = ''
        var arrStatus = item.status_alt

        switch (item.status) {
          case 'in_process':
            name = arrStatus[0]
            break;

          case 'closed':
            name = arrStatus[1]
            break;

          case 'in_preparation':
            name = arrStatus[2]
            break;

          case 'pending_shipping':
            name = arrStatus[3]
            break;

          case 'in_transport':
            name = arrStatus[4]
            break;

          case 'delivered':
            name = arrStatus[5]
            break;

          case 'cancel':
            name = arrStatus[6]
            break;
        }

        // system manufacture status
        if(item.status_system_manufacture && this.configurations) {
          if(JSON.parse(item.status_system_manufacture).status == 'ok') {
            name = this.configurations[11].value_string
          }
          if(JSON.parse(item.status_system_manufacture).status == 'error') {
            name = this.configurations[12].value_string
          }
        }
        // fin

        return name
      },

      // CREDIT SITUATION
      situationCreditMessage(item) {
        if(item.customer) {
          var message = "<b>Fecha:</b> "+ moment(item.customer.bcra_status.fecha).format('DD/MM/YYYY') +"<br><b>Situación:</b> "+ item.customer.bcra_status.situacion +"<br><b>Cheques Rechazados:</b> " + item.customer.bcra_status.rechazos
          return message;
        } else {
          return '';
        }
      },

      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('filter_crud_orders_sellers', JSON.stringify(this.filters))
      },
      restoreFilterStorage() {
        if(Storage.getValue('filter_crud_orders_sellers')) {
          this.filters = Object.assign({}, this.filters, JSON.parse(Storage.getValue('filter_crud_orders_sellers')))
        }
      },
    }
  }
</script>
<style>
  .crud-orders-nro-internal {
    color: #6200ee;
    font-size: 12px;
  }
  .order-total-table-paid {
    color: darkgreen;
    font-weight: 700;
  }
  .order-total-table-nopaid {
    color: darkred;
    font-weight: 700;
  }
  .crud-orders-view-tabs .nav-link {
    padding: 8px 6px;
  }
  .crud-orders-view-tabs > .col-auto {
    padding-left: 2px;
    padding-right: 2px;
  }
  .crud-orders-wizard .wizard-header {
    padding: 0px;
  }
  .crud-orders-wizard .wizard-card-footer {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 4px 0;
  }
  .crud-orders-wizard .wizard-card-footer .wizard-footer-left,
  .crud-orders-wizard .wizard-card-footer .wizard-footer-right { float: none !important; }
  .crud-orders-wizard .wizard-card-footer .wizard-footer-right { margin-left: auto; }
  .crud-orders-wizard .wizard-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 112px;
    height: 36px;
    padding: 6px 14px;
    border-width: 1px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: var(--app-font-semibold);
    box-shadow: none;
    transition: background-color .15s ease, border-color .15s ease, color .15s ease;
  }
  .crud-orders-wizard .wizard-footer-left .wizard-btn::before,
  .crud-orders-wizard .wizard-footer-right .wizard-btn::after {
    font-family: 'Material Symbols Rounded';
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-feature-settings: 'liga';
    line-height: 1;
  }
  .crud-orders-wizard .wizard-footer-left .wizard-btn::before { content: 'arrow_back'; margin-right: 6px; }
  .crud-orders-wizard .wizard-footer-right .wizard-btn::after { content: 'arrow_forward'; margin-left: 6px; }
  .crud-orders-wizard .wizard-footer-left .wizard-btn {
    background-color: var(--app-color-surface) !important;
    border-color: var(--app-color-border-strong) !important;
    color: var(--app-color-text-secondary) !important;
  }
  .crud-orders-wizard .wizard-footer-left .wizard-btn:hover {
    background-color: var(--app-color-surface-subtle) !important;
    color: var(--app-color-text) !important;
  }
  .crud-orders-wizard .wizard-footer-right .wizard-btn {
    background-color: var(--app-color-primary) !important;
    border-color: var(--app-color-primary) !important;
    color: #fff !important;
  }
  .crud-orders-wizard .wizard-footer-right .wizard-btn:hover { filter: brightness(.94); }
  @media (max-width: 767.98px) {
    .crud-orders-wizard .wizard-card-footer { gap: 8px; padding: 12px 0 0; }
    .crud-orders-wizard .wizard-footer-left,
    .crud-orders-wizard .wizard-footer-right { display: flex; flex: 1 1 0; }
    .crud-orders-wizard .wizard-card-footer .wizard-footer-right { margin-left: 0; }
    .crud-orders-wizard .wizard-footer-left > span,
    .crud-orders-wizard .wizard-footer-right > span { display: block; width: 100%; }
    .crud-orders-wizard .wizard-btn { width: 100%; min-width: 0; }
  }

  /* Stat "Items" y cajita de totales (Subtotal/Descuento/Total) — mismo
     patrón tokenizado que crudOrders.vue (docs/modal-interfaces, sección 7). */
  .crud-orders-stat {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px 8px;
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    background: var(--app-color-surface-subtle);
  }
  .crud-orders-stat__label {
    color: var(--app-color-text-muted);
    font-size: var(--app-text-xs);
    font-weight: var(--app-font-semibold);
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  .crud-orders-stat__value {
    font-size: 22px;
    font-weight: var(--app-font-semibold);
    color: var(--app-color-text);
  }
  .crud-orders-totals {
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    background: var(--app-color-surface-subtle);
    padding: 10px 12px;
  }
  .crud-orders-totals__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 4px 0;
    font-size: 12px;
  }
  .crud-orders-totals__row + .crud-orders-totals__row {
    border-top: 1px dashed var(--app-color-border);
  }
  .crud-orders-totals__label {
    color: var(--app-color-text-muted);
    font-weight: var(--app-font-semibold);
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.02em;
    flex: 1 1 auto;
    min-width: 0;
  }
  .crud-orders-totals__value {
    font-weight: var(--app-font-semibold);
    text-align: right;
    white-space: nowrap;
    flex: 0 0 auto;
  }
  .crud-orders-totals__row--total {
    border-top: 2px solid var(--app-color-primary) !important;
    margin-top: 4px;
    padding-top: 8px;
  }
  .crud-orders-totals__row--total .crud-orders-totals__label,
  .crud-orders-totals__row--total .crud-orders-totals__value {
    font-size: 14px;
    color: var(--app-color-text);
  }
  .crud-orders-totals__discount-group {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 0 0 auto;
  }
  .crud-orders-totals__discount {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .crud-orders-totals__discount input,
  .crud-orders-totals__discount select {
    width: 62px;
    height: 26px;
    padding: 2px 4px;
    text-align: right;
  }
  .crud-orders-totals__discount-suffix {
    color: var(--app-color-text-muted);
    font-size: 12px;
  }
  .orders-seller-form-modal-dialog {
    max-width: min(1400px, calc(100vw - 24px));
  }
</style>
<style scoped>
  hr {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .crud-orders-observations {
    overflow: auto;
    max-height: 70px;
    font-size: 12px;
  }
  .b-avatar {
    width: 25px;
    height: 25px;
  }
</style>
